 import React from 'react'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles/index'
import Stepper from '@material-ui/core/Stepper/index'
import Step from '@material-ui/core/Step/index'
import StepButton from '@material-ui/core/StepButton/index'
import StepLabel from '@material-ui/core/StepLabel/index'
import yn from 'yn'

const BkFlowStepsDefault = props => {
	const {
		activeStep,
		handleStepperNavigation,
		hotelLabels,
		steps
	} = props

	const theme = createMuiTheme({
		overrides: {
			MuiStepper: {
				root: {
					background: '#e4e4e4',
				}
			},
			MuiStepPosition: {
				active: {
					fill: '#0083A8',
				},
			},
			MuiStepIcon: {
				active:{
					fill: '#0083a8',
				},
				completed: {
					fill: '#000',
				},
			},
		},
	})

	let confirmationStep = 3

	if (!yn(process.env.REACT_APP_COMPONENT_PRE_ENHANCEMENTS)) {
		confirmationStep = 2
	}

	return (
		<MuiThemeProvider theme={ theme }>
			<Stepper activeStep={ activeStep } className="row center-xs">
				{ steps.map((label, index) => {

					const props = {}
					const labelProps = {}

					return (
						<Step
							key={ label }
							{ ...props }
							>
							{ Number(activeStep) === Number(confirmationStep) ?
								<StepLabel className="bk-flow-steps__button" { ...labelProps }>
									<span className="bk-flow-steps__labels">{label}</span>
								</StepLabel>
							:
								<StepButton
									className={activeStep === index ? 'active-step' : null}
									onClick={ () => handleStepperNavigation(index) }
								>
									<StepLabel className="bk-flow-steps__button" { ...labelProps }>
										<span className="bk-flow-steps__labels">{label}</span>
										{ yn(process.env.REACT_APP_COMPONENT_BANNER_STEPPER_EDIT_LABELS) &&
											activeStep > index &&
											Number(activeStep) < Number(confirmationStep) &&
												<span className="step-label__complete">
													{ hotelLabels && hotelLabels.edit ? hotelLabels.edit : 'Edit'}
												</span>
										}
									</StepLabel>
								</StepButton>
							}
						</Step>
					)
				})}
			</Stepper>
		</MuiThemeProvider>
	)
}

export default BkFlowStepsDefault


// WEBPACK FOOTER //
// ./src/components/structure/stepper/layouts/BkFlowStepsDefault.js